module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNi43NSIgY3k9IjYuMzI2MTciIHI9IjYiIGZpbGw9IiNBOEE4QTgiLz4KPHBhdGggZD0iTTUuNTY0MjggNC4xNDQ1M0w3LjkzNDU3IDYuNDE1MjhMNS43MzAxNCA4LjUwODE3IiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/next.svg
// module id = KkNP
// module chunks = 0